<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="2">
        <strong>Legenda:</strong>
      </el-col>
      <el-col :span="2">
        <el-tag class="Red"> Sin Ejecutar </el-tag>
      </el-col>
      <el-col :span="2">
        <el-tag class="Green"> Ejecutado </el-tag>
      </el-col>
      <el-col :span="2">
        <el-tag class="Yellow"> Mes Actual </el-tag>
      </el-col>
    </el-row>
    <el-row>
      <PaymentAndInvoicingReportFilters
        @onYearSelected="OnYearSelected"
        @onMonthSelected="OnMonthSelected"
        @onPaymentTypeSelected="OnPaymentTypeSelected"
        @ExecutionSelected="OnExecutionSelected"
        @PaymentSelected="OnPaymentSelected"
        @OnInvoiceTypeSelected="OnInvoiceTypeSelected"
      />
    </el-row>
    <el-row>
      <PaymentAndInvoicingReportTable
        :TabSelected="ActualTabValue"
        :YearSelected="yearSelected"
        :MonthSelected="monthSelected"
        :PaymentTypeSelected="PaymentTypeSelected"
        :PaymentSelected="PaymentSelected"
        :ExecutionSelected="ExecutionSelected"
        :InvoiceType="invoiceType"
      />
    </el-row>
  </div>
</template>

<script>
import PaymentAndInvoicingReportTable from "@/components/fiances/reports/table/PaymentAndInvoicingReportTable";
import PaymentAndInvoicingReportFilters from "@/components/fiances/reports/filters/PaymentAndInvoicingReportFilters";

const actualYear = new Date().getFullYear();
const actualMonth = new Date().getMonth() + 1;

export default {
  name: "PaymentAndInvoicingReport",
  components: {
    PaymentAndInvoicingReportTable,
    PaymentAndInvoicingReportFilters
  },
  props: {
    TabSelected: {
      type: String,
      defaul: "",
      required: true
    }
  },
  data() {
    return {
      yearSelected: actualYear,
      monthSelected: actualMonth,
      PaymentTypeSelected: 2,
      PaymentSelected: "",
      ExecutionSelected: null,
      invoiceType: ""
    };
  },

  mounted() {},
  computed: {
    ActualTabValue() {
      return this.TabSelected;
    }
  },
  methods: {
    OnYearSelected(year) {
      this.yearSelected = year;
    },
    OnMonthSelected(month) {
      this.monthSelected = month;
    },
    OnPaymentTypeSelected(value) {
      this.PaymentTypeSelected = value;
    },
    OnPaymentSelected(value) {
      this.PaymentSelected = value;
    },
    OnExecutionSelected(value) {
      this.ExecutionSelected = value;
    },
    OnInvoiceTypeSelected(type) {
      this.invoiceType = type;
    }
  }
};
</script>

<style scoped>
.Bold {
  font-weight: bold;
}
.Blue {
  color: blue;
}
.Red {
  color: darkred;
  background-color: lightsalmon;
  border-color: darkred;
}
.Green {
  color: darkgreen;
  background-color: lightgreen;
  border-color: darkgreen;
}
.Yellow {
  color: darkorange;
  background-color: lightgoldenrodyellow;
  border-color: darkorange;
}
</style>
